import axios from "axios";

export function getMissingPayments() {
  return axios.get(process.env.VUE_APP_API_URL + "PaymentLogRecovery/missing");
}

export function insertMissingPayment(data) {
  return axios.post(process.env.VUE_APP_API_URL + "PaymentLogRecovery/insert", data);
}
